module.exports = __webpack_public_path__ + "9954feb5126a6d5aff92a47fb4545105.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/millenial_employees.jpg
// module id = 1974
// module chunks = 0